module.exports = __webpack_public_path__ + "img/home_menu_11_default.07f7c256.png";